import { useQuery } from 'react-query';

import { getObjectUsers } from 'api/clients/getObjectUser';

export const useGetDataToModalVulnerabilityUser = (objectSlug: string) => {
  const {
    data: objectUsers,
    refetch,
    isLoading,
    isRefetching,
  } = useQuery(['objectUsers', objectSlug], () => getObjectUsers({ objectSlug }), {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: Boolean(objectSlug),
  });

  return {
    objectUsers,
    refetch,
    isLoading,
    isRefetching,
  };
};

export default useGetDataToModalVulnerabilityUser;
